import { Flex } from 'foundations-components/components/Flex';
import CompaignBriefCard from './CampaignBriefCard';
import DataStudioCard from './DataStudioCard';
import LandingPageBuilderCard from './LandingPageBuilderCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SolutionCardsContainer = () => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "column",
    maxInlineSize: "1080px",
    margin: "auto",
    gap: "1200",
    children: [/*#__PURE__*/_jsx(DataStudioCard, {}), /*#__PURE__*/_jsx(CompaignBriefCard, {}), /*#__PURE__*/_jsx(LandingPageBuilderCard, {})]
  });
};
export default SolutionCardsContainer;